var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"cursor--pointer font-size--13",on:{"click":function($event){return _vm.ON_INCREASE_DIALOG()}}},[_vm._t("default",[_vm._v(" 투자 한도 증액하기 "),_c('v-icon',[_vm._v("mdi-chevron-right")])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }